export const MEDIA_IMAGE_URL = "/media/api/files/view";

export const rewriteCdnUrl = (url: any) => {
  if (typeof url !== "string") return url;
  return url
    .replace(/^http:\/\//i, "https://")
    .replace(/^https:\/\/ninex\.s3\.ap-southeast-1\.amazonaws\.com/i, "https://cdn.nineqr.com")
    .replace(/^https:\/\/s3\.ap-southeast-1\.amazonaws\.com\/ninex/i, "https://cdn.nineqr.com");
};

export const getMediaUrl = (value: any, params: any = {}) => {
  if (!value) return value;
  if (typeof value === "string" && /^https?:\/\//i.test(value)) return rewriteCdnUrl(value);
  return generatorMediaURL(value, params);
};

export const generatorMediaURL = (id: any, params: any = {}) => {
    if (typeof id === "string" && /^https?:\/\//i.test(id)) return rewriteCdnUrl(id);
    return `${MEDIA_IMAGE_URL}?id=${id}${Object.keys(params).length > 0
        ? `&${Object.keys(params)
          .map((k) => `${k}=${encodeURIComponent(params[k])}`)
          .join("&")}`
        : ""
      }`;
};
